<template>
	<section>
        <!-- 按钮展示 -->
        <div class="margin-bottom-10">
            <vButton style="position:absolute;right:10px" theme="default" @click="cancel">返回</vButton>
        </div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData" placeholder="--"></compFormQuery>
		</compWrapper>
		<compWrapper title="产品信息" theme="primary">
			<vTableSimple class="margin-layout" :data="productList" :columns="getCusproductColumns"></vTableSimple>
		</compWrapper>
		<compLog wrapper :data="logList"></compLog>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { HttpReturnProcessOrderDetail } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';

export default {
	mixins: [mixin],
    props:['activeids'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading: false,
			id: this.$route.query.id || this.activeids,
			formData: {},
			productList: [],
			logList: [],
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList', 'getBillcusWareList']),
		getBase() {
			return [{
				label: "退货处理单号",
				key: "returnProcessOrderNo",
			},
            {
				label: "状态",
				key: "status",
				options: this.getSalesHandleOrderStatus,
                render: ( h ) => {
                        const status = this.formData.status
                        const { label = '', theme} = this.getSalesHandleOrderStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return  <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                    }
			},
            {
				label: "退货处理计划单号",
				key: "returnProcessPlanOrderNo",
			},
            {
				label: "来源单号",
				key: "sourceNo",
			},
			{
				label: "仓库",
				key: "orgWarehouseCode",
                render:(h)=>{
                    const wareHouse=this.getUserManageWarehouseList.filter(item=>item.attach.code === this.formData.orgWarehouseCode)
                    return <div>{ wareHouse.length > 0 ? wareHouse[0].label : '--'}</div>
                }
			},
			{
				label: "项目",
				key: "lineId",
				options: this.getCusproductList,
			},
			{
				label: "备注",
				key: "remark",
			}];
		},
		getCusproductColumns() {
            return[
                {
                    title: 'No',
                    type: 'index',
                    width: 60
                },
                {
                    title: 'SKU',
                    key: 'sku'
                },
                {
                    title: '原库存类型',
                    key:'inventoryType',
                    render: (h, {row})=>{
                        return row.inventoryType === 0 ? '可售库存' : row.inventoryType === 1 ? '不可售库存' : '--'
                    }
                },
                {
                    title: '建议处理方式/更换后SKU',
                    render:(h,{row})=>{
                        return <div>
                            <div>{ this.findRenderLabel(this.getHandleType, row.goodsReturnType)|| '--' }</div>
                            <div>{ row.newSku || '--' }</div>
                        </div>
                    }
                },
                {
                    title: '数量',
                    key: 'processQty'
                },
                {
                    title: '处理后库存类型',
                    key:'afterInventoryType',
                    render: (h, {row})=>{
                        return row.afterInventoryType === 0 ? '可售库存' : row.afterInventoryType === 1 ? '不可售库存' : '--'
                    }
                },
                {
                    title: '更新时间',
                    key:'updatedAt'
                },
            ]
		},
    },
	methods: {
		//获取计划单详情
		getDetail() {
			this.loading = true;
			HttpReturnProcessOrderDetail({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.processOrderEntity;
				this.productList = data.processOrderItemList;
				this.logList = data.opLogEntityList;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		cancel() {
			this.$router.push({
				name: 'salesHandleOrder'
			})
		}
	}
};
</script>
